var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},[_vm._t("share",[_vm._v("邀好友 赚收益")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }